// Generated by scripts/update-seeq-icons.js from src/svg/seeq/report-lock.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcReportLock = {
  prefix: 'fak',
  iconName: 'report-lock' as IconName,
  icon: [
    1139,
    1024,
    [],
    'f955',
    'M1036.1 97.1h-96.2v-35.6c0-34-27.5-61.5-61.5-61.5h-300.1c-34 0-61.5 27.5-61.4 61.5v35.6h-96.3c-50.1 0-89.8 36.4-98.7 83.3 37.2 4 72.8 13.8 105.2 29.1v-3.2h89.8v34.7c0 34 27.5 61.5 61.4 61.5h300.1c34 0 61.5-27.5 61.5-61.5v-34.7h89.8v709.3h-360v28.3c0 29.1-7.3 55.8-19.4 80.9h385.8c56.6 0 102.7-46.1 102.8-102.7v-722.3c0-56.6-46.1-102.7-102.8-102.7zM830.7 194.1h-205.5v-84.9h205.5v84.9zM484.5 1024c44.5 0 80.1-35.6 80.1-80.1v-277.4c0-33.2-20.2-61.5-48.6-73.6v-77.7c0-128.6-105.2-233.8-233.7-233.7s-233.8 104.3-233.8 233.7v77.7c-28.3 12.1-48.5 40.4-48.5 73.6v277.4c0 44.5 35.6 80.1 80.1 80.1h404.4zM156.1 515.2c0-69.6 56.6-126.2 126.2-126.1s126.2 56.6 126.2 126.1v71.2h-252.4v-71.2z',
  ],
} satisfies IconDefinition;
